import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

import DevIcon from '../../assets/Development.png';
import HRIcon from '../../assets/HRCon.png';
import InternIcon from '../../assets/InternPro.png';

// import DevMockup from '/dev-mockup.png';
// import HRMockup from '/hr-mockup.png';
// import InternMockup from '/intern-mockup.png';

const services = [
  {
    icon: DevIcon,
    title: 'Development',
    description: 'Mobile Apps, Websites, And Custom Software Solutions.',
    link: '/developmentservice',
  },
  {
    icon: HRIcon,
    title: 'HR Consulting',
    description: 'Talent Acquisition, Employee Engagement, And HR Compliance Support.',
    link: '/hrservice',
  },
  {
    icon: InternIcon,
    title: 'Internship Programs',
    description: 'Real-World Training, Mentorship, And Hands-On Project Experience.',
    link: '/internshipprogram',
  },
];

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const getMockupImage = () => {
    switch (hoveredIndex) {
      case 0:
        return "/dev-mockup.png";
      case 1:
        return "/hr-mockup.png";
      case 2:
        return "/intern-mockup.png";
      default:
        return "/dev-mockup.png";
    }
  };

  return (
    <div className="services-container">
      <div className="services-left">
        {services.map((service, idx) => (
          <Link
            to={service.link}
            key={idx}
            className="services-card-link"
            style={{ textDecoration: 'none' }}
            onMouseEnter={() => setHoveredIndex(idx)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="services-card">
              <div className="service-header">
                <img src={service.icon} alt={`${service.title} icon`} className="icon" />
                <h3>{service.title}</h3>
              </div>
              <p>{service.description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="services-right">
        <div className="mockup-wrapper">
          {getMockupImage() && (
            <>
              <img src={getMockupImage()} alt="Mockup Preview" className="mockup-img fade-in" />
              {/* <p className="mockup-desc">
                Mobile Apps, Websites, And Custom Software Solutions And Design UI/UX Services.
              </p> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Services;
